var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Circle_Grid",
    "data-name": "Circle Grid"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    fill: "#f6c863",
    r: 64
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#62667c",
    height: 79.179,
    rx: 3.734,
    width: 82,
    x: 23,
    y: 24.411
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.515 39.799h72.971v59.276h-72.971z",
    fill: "#eeefee"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.568,
    cy: 32.105,
    fill: "#2cbfae",
    r: 2.194
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.878,
    cy: 32.105,
    fill: "#ef5261",
    r: 2.194
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.223,
    cy: 32.105,
    fill: "#f6c863",
    r: 2.194
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#828a9e",
    height: 3.376,
    rx: 1.688,
    width: 36.375,
    x: 30.625,
    y: 30.417
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#575b6d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m85.042 75.856v13.9h-42.083v-13.9h5.211v8.68h31.66v-8.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.012 65.358h-5.83v-16.24h-10.364v16.225h-5.829l11.011 14.024z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFile);
export default __webpack_public_path__ + "static/media/download-file.bdf62488186da6f8750fcef938bb48f5.svg";
export { ForwardRef as ReactComponent };